var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEdit = function SvgEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#5B5D60",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.667,
    d: "M2.397 15.096c.038-.344.057-.517.11-.678q.068-.214.194-.404c.093-.141.215-.264.46-.509L14.167 2.5A2.357 2.357 0 1 1 17.5 5.833L6.495 16.84c-.245.245-.368.367-.51.46a1.7 1.7 0 0 1-.403.195c-.162.052-.334.071-.678.11l-2.82.313z"
  })));
};
export { SvgEdit as ReactComponent };
export default __webpack_public_path__ + "a8faae57f76e9ab58fdfd23bf0a02b7a.svg";